



























import { Component, Prop, Vue } from 'vue-property-decorator';
import { mdbContainer, mdbRow, mdbCol } from '@folky-tools/mdbvue';
import mdbFileUpload from '@folky-tools/mdb-file-upload/src/components/mdbFileUpload.vue';
@Component({
    components: {
        mdbContainer,
        mdbRow,
        mdbCol,
        mdbFileUpload
    }
})
export default class FileUpload extends Vue {
    @Prop({ required: true, type: String }) private src?: string;
    @Prop({ required: true, type: String }) private maxSize!: string;
    @Prop({ type: String, default: 'image/jpeg, image/png' }) private acceptedFileTypes!: string;
    private file?: File;

    get text(): any {
        return {
            able: { single: this.$i18n.t('components.shared.fileUpload.uploadDragEnabled').toString() },
            unable: { single: this.$i18n.t('components.shared.fileUpload.uploadDragDisabled').toString() }
        };
    }

    get secondaryText(): any {
        return {
            able: { single: this.$i18n.t('components.shared.fileUpload.replaceDragEnabled').toString() },
            unable: { single: this.$i18n.t('components.shared.fileUpload.replaceDragDisabled').toString() }
        };
    }

    get fileMaxSize(): string {
        return this.maxSize!;
    }

    get fileMaxSizeText(): string {
        let unitText: string = '';
        switch (this.maxSize.slice(-1)) {
            case 'K':
                unitText = 'KB';
                break;
            case 'M':
                unitText = 'MB';
                break;
            case 'G':
                unitText = 'GB';
                break;
        }

        return `${this.maxSize.slice(0, this.maxSize.length - 1)} ${unitText}`;
    }

    public getFinalImageFile(): File {
        return this.file!;
    }

    private async mounted(): Promise<void> {
        (this.$refs.fileUpload as any).internalFiles = [await this.getFileData()];
        (this.$refs.fileUpload as any).getImagePreviews();
    }

    private async getFileData(): Promise<File> {
        const fetch = (url: string): Promise<any> =>
            new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.onreadystatechange = event => {
                    if (xhr.readyState !== 4) {
                        return;
                    }
                    if (xhr.status >= 200 && xhr.status < 300) {
                        resolve(xhr.response);
                    } else {
                        reject(xhr.statusText);
                    }
                };
                xhr.open('GET', url, true);
                xhr.responseType = 'blob';
                xhr.send();
            });
        const response = await fetch(this.src!);
        response.lastModifiedDate = new Date();
        response.name = this.src!.replace(/^.*[\\\/]/, '');
        return response as File;
    }

    private onFileChanged(files: File[] | null | undefined): void {
        if (!files || files.length < 1) {
            return;
        }
        this.file = files[0];
        if ((this.$refs.fileUpload as any).isPicture(this.file.name)) {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                this.$emit('update:src', reader.result);
            });
            reader.readAsDataURL(this.file);
        } else if (this.file.name.slice(-4) === '.pdf') {
            const reader = new FileReader();
            reader.addEventListener('load', () => {
                this.$emit('update:src', reader.result);
            });
            reader.readAsDataURL(this.file);
        } else {
            this.$emit('update:src', undefined);
        }
    }
}
